<div>

    <app-core-article-search [loadItemsSourceCallback]="loadItemsSourceCallback"></app-core-article-search>

</div>
